<template>
  <div>
    <div>
      <v-layout row justify-end class="mt-2">
        <v-flex xs12>
          <InputSearch
            class="mb-3"
            @clickAdvancedSearch="showSearchAdvanced = true"
            @clickSearch="onSearch"
            @clearSearch="
              clearSearch()
              isSearch = false
            "
            :isSearch="isSearch"
            :search="filter"
            :placeholder="
              'ค้นหา, รหัสผู้ให้บริการ, ผู้ให้บริการ, รหัสสินค้า, ชื่อสินค้า, รายละเอียด, ประเภทสิขสิทธ์, ตัวแทนขาย'
            "
            :clearAdvancedSearch="clearAdvancedSearch"
            showClearAdvancedSearch
            showAdvancedSearch
          />
        </v-flex>
      </v-layout>

      <v-flex xs12>
        <div style="display: flex; align-items: center">
          <v-flex>
            <Typography h2 bold :label="$t('provider & product')" />
          </v-flex>
          <v-btn
            variant="outlined"
            :v-tooltip="กรมบัญชีกลาง"
            @click="sendEGP"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            e-GP
            <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
            <!-- <img
              src="/static/img/ProductList.png"
              alt
              class="responsive-img"
              style="height: 16px"
            /> -->
          </v-btn>
          <v-btn
            variant="outlined"
            :v-tooltip="$t('export')"
            @click="exportData"
            :loading="loading"
            icon
            color="#BECCDB"
            style="border-radius: 50% !important"
          >
            <!-- <i class="fa fa-download" aria-hidden="true"></i> -->
            <img
              src="/static/img/exportfilter.png"
              alt
              class="responsive-img"
              style="height: 16px"
            />
          </v-btn>
          <exportxlsx ref="exbtn" :value="exData" style="display: none"></exportxlsx>
          <v-btn
            variant="outlined"
            v-tooltip="'เลือกคอลัมน์'"
            icon
            :loading="loading"
            :color="drawer ? '#0C2F53' : '#BECCDB'"
            @click.stop="drawer = !drawer"
            style="border-radius: 50% !important"
          >
            <img
              :src="`/static/img/${drawer ? 'filterColumnWhite.png' : 'filterColumnBlack.png'}`"
              alt
              class="responsive-img"
              style="height: 20px"
            />
          </v-btn>
        </div>
      </v-flex>

      <!-- <v-layout wrap>
        <v-flex xs12>
          <v-layout row wrap justify-end xs12 sm8 class="text-xs-right mb-0">
            <v-flex class="mr-1">
              <multiselect
                v-model="filter.campaign"
                :options="campaign"
                label="campaignname"
                selectLabel
                selectedLabel
                placeholder="Campaign"
                :searchable="false"
                deselect-label
                @input="selectfilter()"
              ></multiselect
            ></v-flex>
            <v-flex class="ml-1">
              <multiselect
                :options="typeOptions"
                v-model="filter.type"
                selectLabel
                selectedLabel
                placeholder="Type"
                :searchable="false"
                deselect-label
                @input="selectfilter()"
              ></multiselect
            ></v-flex>
            <v-flex class="ml-1">
              <multiselect
                :options="showCategory"
                v-model="filter.category"
                label="categoryname"
                selectLabel
                selectedLabel
                placeholder="Category"
                :searchable="false"
                deselect-label
                @input="selectfilter()"
              ></multiselect
            ></v-flex>
            <v-flex xs12 class="form-control pt-1">
              <div class="depainput form-control mb-3" style="position: relative">
                <input
                  v-model="filter.text"
                  @keyup="filterdata()"
                  style="padding-right: 47px !important"
                  type="text"
                />
                <v-btn @click="filterdata()" style="position: absolute; right: 0px; top: 0px" icon
                  ><v-icon color="primary">search</v-icon></v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout> -->
      <!-- <div>
        <div class="text-xs-right">
          <v-btn
            flat
            color="red"
            @click="clearFilter"
            style="color: white; text-transform: capitalize"
            class="px-4"
            >Clear all filters</v-btn
          >
        </div>
      </div> -->
      <!-- <v-pagination
        v-if="pageCount"
        @input="changepage"
        v-model="page"
        :length="pageCount"
      ></v-pagination> -->

      <v-navigation-drawer v-model="drawer" right fixed temporary style="top: 200px; padding: 20px">
        <v-list density="compact" nav>
          <v-flex xs12 style="display: flex; align-items: center; justify-content: space-between">
            <!-- <div class="color-darkBlue bold7 fs-20">เลือกคอลัมน์</div> -->
            <Typography h3 bold label="เลือกคอลัมน์" />
            <v-icon @click.stop="drawer = false">close</v-icon>
          </v-flex>
          <div style="display: flex">
            <v-flex xs10 class="mb-2 mt-2">
              <div
                style="width: 100%; display: flex; align-items: center"
                class="form-group has-search"
              >
                <div
                  style="width: 100%; display: flex; justify-content: flex-end; border-right: 0px"
                  class="form-control"
                >
                  <input
                    @change="changeSearchColumn"
                    type="search"
                    class="depainput rsu mb-0"
                    placeholder="Search"
                    name="search"
                    v-model="searchColumn"
                    style="border-radius: 0px; border-right: 0px"
                  />
                </div>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-left: 0px;
                  border-right: 0px;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  class="fa fa-times-circle form-control-feedback pointer"
                  style="color: #00000040"
                  @click="clearSearchColumn"
                ></span>
              </div>
            </v-flex>
            <v-flex xs2 class="mb-2 mt-2">
              <div
                class="pointer"
                style="
                  border: 1px solid #cfcfcf;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-top-color: initial !important;
                  border-bottom-color: initial !important;
                "
              >
                <span
                  @click="changeSearchColumn"
                  class="fa fa-search form-control-feedback"
                  style="color: #bdbdbd"
                ></span>
              </div>
            </v-flex>
          </div>
          <div style="overflow: auto; height: 380px">
            <div
              class="mt-2"
              style="display: flex"
              v-for="item in this.column"
              @click="clickShowColumn(item)"
              :key="item"
            >
              <v-checkbox
                color="#0C2F53"
                style="display: flex; flex: none !important; margin-top: 0px; padding-top: 0px"
                v-model="showColumn.includes(item)"
                hide-details
                dense
              >
              </v-checkbox>
              <Typography h5 :label="item" />
            </div>
          </div>
        </v-list>
      </v-navigation-drawer>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <v-data-table
        v-else
        :headers="headers"
        :items="showData"
        hide-actions
        class="elevation-1 col-12"
      >
        <template v-slot:headers="props">
          <tr style="background-color: #152d53; color: white">
            <!-- <th style="background-color: #152d53; color: yellow; text-align: left" v-for="(header, k) in props.headers"
              :key="header.text + k">
              {{ header.text }}
            </th> -->
            <th
              style="background-color: #152d53; color: yellow"
              v-for="header in props.headers"
              v-show="showColumn.includes(header.text) || header.text == ''"
              :key="header.text"
            >
              <div v-show="showColumn.includes(header.text)">{{ header.text }}</div>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr class="depatable">
            <td class="text-xs-left" v-show="showColumn.includes('รหัสผู้ให้บริการ')">
              <Typography left h5 :label="props.item.techproviderid || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ผู้ให้บริการ')">
              <Typography
                style="width: 250px"
                left
                h5
                :label="props.item.techprovidername || '-'"
              />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('รหัสสินค้า')">
              <Typography left h5 :label="props.item.productid || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ชื่อสินค้า')">
              <Typography style="width: 250px" left h5 :label="props.item.productname || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ราคาสินค้า')">
              <Typography left h5 :label="props.item.price || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('รายละเอียด')">
              <Typography style="width: 400px" left h5 :label="props.item.description || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('เรทติ้ง')">
              <Typography left h5 :label="props.item.score || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ประเภทธุรกิจ')">
              <Typography style="width: 200px" left h5 :label="props.item.typename || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('หมวดหมู่')">
              <Typography style="width: 200px" left h5 :label="props.item.categoryname || '-'" />
            </td>

            <td class="text-xs-left" v-show="showColumn.includes('แท็ก')">
              <Typography left h5 :label="props.item.tags || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ประเภทสิขสิทธ์')">
              <Typography left h5 :label="props.item.copyrighttype || '-'" />
            </td>
            <td class="text-xs-left" v-show="showColumn.includes('ตัวแทนขาย')">
              <Typography
                style="width: 240px"
                left
                h5
                :label="props.item.salesrepresentatives || '-'"
              />
            </td>
            <td class="text-xs-center" v-show="showColumn.includes('ตราสัญลักษณ์')">
              <div
                style="text-decoration: underline; color: #26588b"
                class="cursor-5"
                @click.stop="clickDetail(props.item)"
              >
                ดูรายละเอียด
              </div>
            </td>
            <td class="text-xs-center" v-show="showColumn.includes('เอกสาร')">
              <!-- <Typography
                style="width: 240px"
                left
                h5
                :label="props.item.document || '-'"
              /> -->
              <div
                style="text-decoration: underline; color: #26588b"
                class="cursor-5"
                @click.stop="clickDoc(props.item)"
              >
                Click
              </div>
            </td>
            <!-- <td class="text-xs-center" style="width: 70px">
              <TooltipTable
                :datas="props"
                @Delete="deleteMember(props.item.productid)"
                showDelete
                :showIsEdit="false"
              ></TooltipTable>
            </td> -->
          </tr>
        </template>
      </v-data-table>
      <!-- <v-pagination
        v-model="pagination.page"
        :length="Math.ceil(filteredData2.length / pagination.rowsPerPage)"
      >
      </v-pagination> -->
    </div>
    <v-dialog v-model="showSearchAdvanced" width="500px" persistent>
      <v-card style="border-radius: 10px">
        <v-btn style="float: right" @click="showSearchAdvanced = false" icon
          ><v-icon>close</v-icon></v-btn
        >
        <div class="pa-4">
          <div style="display: flex">
            <i
              class="fa fa-filter color-darkBlue"
              style="font-size: 18px; display: flex; align-items: center"
              aria-hidden="true"
            ></i>
            <Typography h3 semiBold label="Advanced Search" class="pl-1" />
          </div>
          <div class="rsu">
            <v-layout row wrap>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="แคมเปญ" />
                <multiselect
                  v-model="filter.campaign"
                  :options="campaign"
                  label="campaignname"
                  selectLabel
                  selectedLabel
                  placeholder="แคมเปญ"
                  :searchable="false"
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="ประเภทธุรกิจ" />
                <multiselect
                  :options="typeList.map(val => val.typeid)"
                  v-model="filter.type"
                  :custom-label="customLabelFilter"
                  @input="
                      {
                        getCategory(), 
                        filter.category = null
                      }
                    "
                  placeholder="ประเภทธุรกิจ"
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="หมวดหมู่" />
                <multiselect
                  :options="category"
                  v-model="filter.category"
                  label="categoryname"
                  selectLabel
                  selectedLabel
                  placeholder="หมวดหมู่"
                  :allow-empty="false"
                  :searchable="false"
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="ชื่อสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="ชื่อสมาชิก"
                    placeholder="ชื่อสมาชิก"
                    v-model="filter.membername"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="รหัสสมาชิก" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="รหัสสมาชิก"
                    placeholder="รหัสสมาชิก"
                    v-model="filter.memberid"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="รหัสสินค้า" />
                <div style="width: 100%" class="form-control">
                  <input
                    name="รหัสสินค้า"
                    placeholder="รหัสสินค้า"
                    v-model="filter.productid"
                    type="text"
                    class="depainput rsu mb-0"
                  />
                </div>
              </v-flex>
              <v-flex xs12 class="mb-2 mt-2 pr-1">
                <Typography class="pr-3" h5 label="ตราสัญลักษณ์" />
                <multiselect
                  :options="symbols.map(val => val.id)"
                  :custom-label="customLabel"
                  v-model="filter.symbols"
                  label="name"
                  selectLabel
                  selectedLabel
                  placeholder="ตราสัญลักษณ์"
                  deselect-label
                ></multiselect>
              </v-flex>
            </v-layout>
            <div class="pt-2" style="display: flex; justify-content: center">
              <Button
                :loading="searchloading"
                outline
                :label="$t('Clear Search')"
                @click="
                  clearSearch()
                  isSearch = false
                "
              />
              <Button :loading="searchloading" depressed :label="$t('Search')" @click="onSearch" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalDetail" persistent width="500px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <Typography h2 bold label="รายละเอียดตราสัญลักษณ์ที่ได้รับ" />
            <v-icon style="display: flex; align-items: center" @click="modalDetail = false"
              >close</v-icon
            >
          </div>
          <div class="rsu mt-3">
            <div v-if="dataDetail.length ? dataDetail[0].badgeid === null : []">
              <div style="text-align: center">
                <img
                  :src="'/static/img/emblem.png'"
                  alt
                  class="responsive-img mb-1"
                  style="height: 90px"
                />
              </div>
              <v-layout row wrap>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography bold center h5 label="คุณไม่มีตราสัญลักษณ์ในสินค้านี้" />
                </v-flex>
              </v-layout>
              <div style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('cancel')"
                  @click="modalDetail = false"
                />
                <Button
                  :loading="loading"
                  depressed
                  label="เพิ่มตราสัญลักษณ์"
                  @click="
                    modalAddBadges = true
                    modalDetail = false
                    typeBadges = 'add'
                  "
                />
              </div>
            </div>
            <div v-else>
              <div
                style="display: flex;justify-content: end;align-items: center;"
                class="btn white"
                @click="updataBadges"
              >
                <img
                  src="/static/img/TooltipEdit.png"
                  alt
                  class="responsive-img mb-1"
                  style="height: 22px"
                />
                <Typography medium h5 label="แก้ไข" />
              </div>
              <v-data-table
                :headers="headersSymbols"
                :items="dataDetail"
                hide-actions
                class="elevation-1 col-12"
              >
                <template v-slot:headers="props">
                  <tr style="background-color: #152d53; color: white">
                    <th
                      style="background-color: #152d53; color: yellow; text-align: left"
                      v-for="(header, k) in props.headers"
                      :key="header.text + k"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr class="depatable">
                    <td class="text-xs-left">
                      <Typography left h5 :label="props.index + 1" />
                    </td>
                    <td class="text-xs-left">
                      <Typography left h5 :label="customLabel(props.item.badgeid) || '-'" />
                    </td>
                    <td class="text-xs-left">
                      <img
                        v-if="props.item.badgelevel"
                        :src="getOptionsImage(props.item)"
                        alt
                        class="responsive-img"
                        style="height: 30px"
                      />
                      <img
                        v-else
                        :src="props.item.badgeImage"
                        alt
                        class="responsive-img"
                        style="height: 30px"
                      />
                    </td>
                    <td class="text-xs-left">
                      <Typography left h5 :label="props.item.badgelevel || '-'" />
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <Button
                class="mt-2"
                style="display: flex; justify-content: center"
                :loading="loading"
                depressed
                label="ปิด"
                @click="modalDetail = false"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalAddBadges" persistent width="500px">
      <v-card v-if="modalAddBadges" style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <Typography
              h2
              bold
              :label="typeBadges === 'add' ? 'เพิ่มตราสัญลักษณ์' : 'แก้ไขตราสัญลักษณ์'"
            />
            <v-icon style="display: flex; align-items: center" @click="cloneBadges">close</v-icon>
          </div>
          <div class="rsu mt-3">
            <v-card-actions class="pt-0" style="flex-direction: column; align-items: flex-start">
              <div style="width: 100%">
                <div
                  v-for="(item, index) in newSymbol"
                  :key="index"
                  style="width: 100%;border: 1px solid #BECCDB;border-radius: 6px;padding: 10px;"
                  class="form-control px-3 mb-3"
                  :class="{ 'has-error': errors.has('ไฟล์ภาพ' + index) }"
                >
                  <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs12>
                      <div
                        style="width: 100%"
                        class="form-control"
                        :class="{ 'has-error': errors.has('ชื่อตราสัญลักษณ์' + index) }"
                      >
                        <div
                          style="display: flex; justify-content: space-between; align-items: center"
                        >
                          <Typography
                            h5
                            semiBold
                            color="color-darkGrey"
                            :label="`ชื่อตราสัญลักษณ์`"
                          />
                          <v-btn
                            v-if="newSymbol.length > 1"
                            icon
                            @click="removeLevel(index)"
                            style="margin-left: 5px !important"
                          >
                            <img
                              src="/static/img/garbage.svg"
                              alt
                              class="responsive-img"
                              style="height: 18px"
                            />
                          </v-btn>
                        </div>
                        <multiselect
                          :options="symbols.map(val => val.id)"
                          :name="'ชื่อตราสัญลักษณ์' + index"
                          :custom-label="customLabel"
                          v-model="item.badgeid"
                          label="name"
                          selectLabel
                          selectedLabel
                          placeholder="ตราสัญลักษณ์"
                          deselect-label
                        ></multiselect>
                        <span class="text-error" v-if="errors.has('ชื่อตราสัญลักษณ์' + index)">{{
                          errors.first('ชื่อตราสัญลักษณ์' + index)
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex xs12 class="mt-3" v-if="getOptions(item)">
                      <div
                        style="width: 100%"
                        class="form-control"
                        :class="{ 'has-error': errors.has('ระดับ' + index) }"
                      >
                        <Typography h5 semiBold color="color-darkGrey" :label="`ระดับ`" />
                        <multiselect
                          :custom-label="customLabelLevel"
                          :options="getOptions(item)"
                          :name="'ระดับ' + index"
                          v-model="item.badgelevel"
                          label="level"
                          selectLabel
                          selectedLabel
                          placeholder="ระดับ"
                          deselect-label
                        ></multiselect>

                        <span class="text-error" v-if="errors.has('ระดับ' + index)">{{
                          errors.first('ระดับ' + index)
                        }}</span>
                      </div>
                    </v-flex>

                    <v-flex xs12 class="mt-3" v-if="getOptionsImage(item)">
                      <Typography
                        h5
                        semiBold
                        color="color-darkGrey"
                        :label="`รูปภาพตราสัญลักษณ์`"
                      />
                      <div style="display: flex;justify-content: center;" class="mt-3 mb-2">
                        <img
                          :name="'รูปภาพตราสัญลักษณ์' + index"
                          :src="getOptionsImage(item)"
                          alt
                          class="responsive-img"
                          style="height: 60px"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
                <div class="text-xs-right" style="display: flex; align-items: center">
                  <v-btn icon @click="addLevel" style="margin-left: 5px !important">
                    <img
                      src="/static/img/addBlue.svg"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                  </v-btn>
                  <Typography h5 semiBold color="color-darkBlue" :label="`เพิ่มตราสัญลักษณ์`" />
                </div>
              </div>
            </v-card-actions>
            <!-- <v-card-actions style="justify-content: center" class="pb-3">
              <div class="text-xs-center rsu">
                <v-btn class="rsu" @click="
                addModal = false
                cancelAddModal = true
                  " round small outline color="primary">
                  <Typography h5 semiBold color="color-darkBlue" :label="$t('cancel')" />
                </v-btn>
                <v-btn class="rsu" :loading="loading" @click="saveData" round small depressed style="color: yellow"
                  color="primary">
                  <Typography h5 semiBold color="color-lightYellow" :label="$t('Save')" />
                </v-btn>
              </div>
            </v-card-actions> -->
            <div style="display: flex; justify-content: center">
              <Button :loading="loading" outline :label="$t('cancel')" @click="cloneBadges" />
              <Button :loading="loading" depressed label="บันทึก" @click="onSave" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalDoc" persistent width="500px">
      <v-card style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <Typography h2 bold label="รายละเอียดเอกสาร" />
            <v-icon style="display: flex; align-items: center" @click="modalDoc = false"
              >close</v-icon
            >
          </div>
          <div class="rsu mt-3">
            <div v-if="dataDoc.length ? dataDoc[0].docid === null : []">
              <v-layout row wrap>
                <v-flex xs12 class="mb-2 mt-2 pr-1">
                  <Typography bold center h5 label="คุณไม่มีเอกสารในสินค้านี้" />
                </v-flex>
              </v-layout>
              <div style="display: flex; justify-content: center">
                <Button
                  :loading="loading"
                  outline
                  :label="$t('cancel')"
                  @click="modalDoc = false"
                />
                <Button
                  :loading="loading"
                  depressed
                  label="เพิ่มเอกสาร"
                  @click="
                    modalAddDoc = true
                    modalDoc = false
                    typeDoc = 'add'
                  "
                />
              </div>
            </div>
            <div v-else>
              <div
                style="display: flex;justify-content: end;align-items: center;"
                class="btn white"
                @click="updataDoc"
              >
                <img
                  src="/static/img/TooltipEdit.png"
                  alt
                  class="responsive-img mb-1"
                  style="height: 22px"
                />
                <Typography medium h5 label="แก้ไข" />
              </div>
              <v-data-table
                :headers="headersDoc"
                :items="dataDoc"
                hide-actions
                class="elevation-1 col-12"
              >
                <template v-slot:headers="props">
                  <tr style="background-color: #152d53; color: white">
                    <th
                      style="background-color: #152d53; color: yellow; text-align: left"
                      v-for="(header, k) in props.headers"
                      :key="header.text + k"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr class="depatable">
                    <td class="text-xs-left">
                      <Typography left h5 :label="props.index + 1" />
                    </td>
                    <td class="text-xs-left">
                      <Typography left h5 :label="props.item.doc_name || '-'" />
                    </td>
                    <td class="text-xs-left">
                      <Typography left h5 :label="props.item.doc_url || '-'" />
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <Button
                class="mt-2"
                style="display: flex; justify-content: center"
                :loading="loading"
                depressed
                label="ปิด"
                @click="modalDoc = false"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalAddDoc" persistent width="500px">
      <v-card v-if="modalAddDoc" style="border-radius: 10px">
        <div class="pa-3">
          <div style="display: flex; justify-content: space-between">
            <Typography
              h2
              bold
              :label="typeDoc === 'add' ? 'เพิ่มเอกสาร' : 'แก้ไขเอกสาร'"
            />
            <v-icon style="display: flex; align-items: center" @click="closeDoc">close</v-icon>
          </div>
          <div class="rsu mt-3">
            <v-card-actions class="pt-0" style="flex-direction: column; align-items: flex-start">
              <div style="width: 100%">
                <div
                  v-for="(item, index) in newSymbol2"
                  :key="index"
                  style="width: 100%;border: 1px solid #BECCDB;border-radius: 6px;padding: 10px;"
                  class="form-control px-3 mb-3"
                >
                <v-layout row wrap class="ma-0 pa-0">
                    <v-flex xs12>
                      <div
                        style="width: 100%"
                        class="form-control"
                        :class="{ 'has-error': errors.has('ชื่อเอกสาร' + index) }"
                      >
                        <div
                          style="display: flex; justify-content: space-between; align-items: center"
                        >
                          <Typography
                            h5
                            semiBold
                            color="color-darkGrey"
                            :label="`ชื่อเอกสาร`"
                          />
                          <v-btn
                            v-if="newSymbol2.length > 1"
                            icon
                            @click="removeLevel(index)"
                            style="margin-left: 5px !important"
                          >
                            <img
                              src="/static/img/garbage.svg"
                              alt
                              class="responsive-img"
                              style="height: 18px"
                            />
                          </v-btn>
                        </div>
                        <input
                          v-model="item.doc_name"
                          placeholder=""
                          type="text"
                          class="depainput rsu "
                          maxlength="20"
                          :name="'ชื่อไฟล์'"
                          data-vv-as="ชื่อไฟล์"
                        />
                        <span class="text-error" v-if="errors.has('ชื่อตัวไฟล์' + index)">{{
                          errors.first('ชื่อไฟล์')
                        }}</span>
                      </div>
                      <uploadalltype
                          ref="file"
                          @onUploaded="onUploadedFile($event,index)"
                          :multiple="false"
                          :showOnlyButton="true"
                        >
                        <template v-slot="{ loading }"> 
                          <v-btn style="width: 142px;" class="mx-0 rsu" round outline color="primary" :loading="loading">
                            <img
                              :src="`/static/img/plusfill.svg`"
                              alt
                              class="responsive-img mr-2"
                              style="height: 20px;"
                            />
                            {{ $t('select file to upload') }}
                          </v-btn>
                          <Typography
                            h7
                            semiBold
                            color="color-lightMediumGrey"
                            :label="$t('upload file size: {size}MB', { size: 10 })"
                          />
                          <input
                            type="hidden"
                            name="Doc url"
                            v-model="doc_url"
                            placeholder="Doc url"
                          />
                          <v-btn class="mx-0 customExamfileBtn" :href="item.doc_url" v-if="item.doc_url">{{
                            item.doc_url | truncate(20)
                          }}</v-btn>
                          <v-btn class="mx-0 clearBtn" v-if="item.doc_url" @click="clearData"
                            ><v-icon>close</v-icon>
                          </v-btn>
                        </template>
                       
                      </uploadalltype>
                    </v-flex>
                  </v-layout>
                </div>
                <div class="text-xs-right" style="display: flex; align-items: center">
                  <v-btn icon @click="addLevel" style="margin-left: 5px !important">
                    <img
                      src="/static/img/addBlue.svg"
                      alt
                      class="responsive-img"
                      style="height: 20px"
                    />
                  </v-btn>
                  <Typography h5 semiBold color="color-darkBlue" :label="`เพิ่มเอกสาร`" />
                </div>
              </div>
            </v-card-actions>
            <div style="display: flex; justify-content: center">
              <Button :loading="loading" outline :label="$t('cancel')" @click="closeDoc" />
              <Button :loading="loading" depressed label="บันทึก" @click="saveDoc" />
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import Exportxlsx from '@/components/elements/exportxlsx'
import Province from '@/assets/js/province.js'
import InputSearch from '@/components/elements/InputSearch.vue'
import Typography from '@/components/elements/Typography.vue'
import Button from '@/components/elements/Button.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Paginations from '@/components/elements/Paginations.vue'
import uploadalltype from '@/components/elements/uploadalltype'
import uploadfile from '@/components/elements/uploadfiletest.vue'

export default {
  components: {
    Multiselect,
    Exportxlsx,
    InputSearch,
    Typography,
    Button,
    TooltipTable,
    Paginations,
    uploadalltype,
    uploadfile
  },
  data() {
    return {
      total: 0,
      searchColumn: '',
      modalDetail: false,
      modalDoc: false,
      dataDetail: [],
      dataDoc: [],
      modalAddBadges: false,
      productid: null,
      showFilter: false,
      clearAdvancedSearch: false,
      showSearchAdvanced: false,
      searchloading: false,
      isSearch: false,
      drawer: false,
      columnAll: [
        'รหัสผู้ให้บริการ',
        'ผู้ให้บริการ',
        'รหัสสินค้า',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'แท็ก',
        'ประเภทสิขสิทธ์',
        'ตัวแทนขาย',
        'ตราสัญลักษณ์',
        'เอกสาร'
      ],
      showColumn: [
        'รหัสผู้ให้บริการ',
        'ผู้ให้บริการ',
        'รหัสสินค้า',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'แท็ก',
        'ประเภทสิขสิทธ์',
        'ตัวแทนขาย',
        'ตราสัญลักษณ์',
        'เอกสาร'
      ],
      symbols: [],
      filter: {
        nameAll: null,
        campaign: null,
        category: null,
        type: null,
        memberid: null,
        membername: null,
        productid: null,
        symbols: null
      },
      pagination: {
        rowsPerPage: 15,
        page: 1
      },
      column: [
        'รหัสผู้ให้บริการ',
        'ผู้ให้บริการ',
        'รหัสสินค้า',
        'ชื่อสินค้า',
        'ราคาสินค้า',
        'รายละเอียด',
        'เรทติ้ง',
        'ประเภทธุรกิจ',
        'หมวดหมู่',
        'แท็ก',
        'ประเภทสิขสิทธ์',
        'ตัวแทนขาย',
        'ตราสัญลักษณ์',
        'เอกสาร'
      ],
      headers: [
        { text: 'รหัสผู้ให้บริการ', align: 'left', value: 'memberid' },
        { text: 'ผู้ให้บริการ', align: 'left', value: 'techprovider' },
        { text: 'รหัสสินค้า', align: 'left', value: 'productid' },
        { text: 'ชื่อสินค้า', align: 'left', value: 'product' },
        { text: 'ราคาสินค้า', align: 'left', value: 'price' },
        { text: 'รายละเอียด', align: 'left', value: 'detail' },
        { text: 'เรทติ้ง', align: 'left', value: 'rating' },
        { text: 'ประเภทธุรกิจ', align: 'left', value: 'type' },
        { text: 'หมวดหมู่', align: 'left', value: 'categoryname' },
        { text: 'แท็ก', align: 'left', value: 'tag' },
        { text: 'ประเภทสิขสิทธ์', align: 'left', value: 'copyrighttype' },
        { text: 'ตัวแทนขาย', align: 'left', value: 'salesrepresentative' },
        { text: 'ตราสัญลักษณ์', align: 'center', value: '' },
        { text: 'เอกสาร', align: 'center', value: 'document' }
        // {
        //   text: '',
        //   align: 'left',
        //   value: 'ตรา Smart City'
        // }
      ],
      headersSymbols: [
        { text: 'จำนวนตราที่ได้รับ', align: 'left', value: 'badgeid' },
        { text: 'ชื่อตราสัญลักษณ์', align: 'left', value: 'badgeName' },
        { text: 'รูปภาพ', align: 'left', value: 'badgeImage' },
        { text: 'ระดับ', align: 'left', value: 'badgelevel' }
      ],
      headersDoc: [
        { text: 'จำนวนเอกสาร', align: 'left', value: 'docid' },
        { text: 'ชื่อ', align: 'left', value: 'doc_name' },
        { text: 'เอกสาร', align: 'left', value: 'doc_url' },
      ],
      exData: [],
      data: [],
      showData: [],
      allData: [],
      campaign: [],
      typeList: [],
      techprovider: [],
      category: [],
      page: 1,
      rowsPerPage: 15,
      loading: false,
      typeBadges: null,
      alltype: [],
      numberPage: {
        page: undefined
      },
      newSymbol: [
        {
          badgeid: null,
          badgelevel: 0
        }
      ],
      newSymbol2: [
        {
          doc_name: null,
          doc_url: null,
        }
      ],
    }
  },
  watch: {
    showData: {
      immediate: true,
      handler(showData) {
        if (showData && showData.length) {
          this.setEx()
        }
      }
    }
  },
  watch: {
    allData: {
      immediate: true,
      handler(allData) {
        if (allData && allData.length) {
          this.setEx()
        }
      }
    }
  },
  computed: {
    getOptions() {
      return levels => {
        const symbol = this.symbols.find(x => x.id === levels.badgeid)
        if (symbol && symbol.levels) {
          return symbol ? (symbol.levels ? symbol.levels.map(val => val.level) : []) : []
        } else {
          return null
        }
      }
    },
    getOptionsImage() {
      return levels => {
        const symbol = this.symbols.find(x => x.id === levels.badgeid)
        // this.newSymbol[index].badgelevel = 0
        if (symbol && symbol.levels && levels.badgelevel !== 0) {
          let symbolLevel = symbol.levels.find(x => x.level === levels.badgelevel)
          return symbolLevel.image_url
        } else if (symbol) {
          return symbol.image_url
        } else {
          return null
        }
      }
    },
    province() {
      return Province
    },
    pageCount() {
      if (this.total) {
        let count = Math.ceil(this.total / this.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.rowsPerPage - this.rowsPerPage : this.rowsPerPage
    },
    body() {
      return {
        form: 'owner',
        approve: 'approve',
        productname: this.filter.nameAll ? this.filter.nameAll : null,
        campaignid:
          this.filter.campaign && this.filter.campaign.id ? this.filter.campaign.id : null,
        typeid: this.filter.type ? this.filter.type : null,
        categoryname:
          this.filter.category && this.filter.category.categoryname
            ? this.filter.category.categoryname
            : null,
        memberid: this.filter.memberid ? this.filter.memberid : null,
        membername: this.filter.membername ? this.filter.membername : null,
        productid: this.filter.productid ? this.filter.productid : null,
        badgeid: this.filter.symbols ? this.filter.symbols : null
      }
    }
  },
  async mounted() {
    await this.setupData()
  },
  methods: {
    clearData() {
      this.newSymbol2 = [
        {
          doc_name: null,
          doc_url: null,
        }
      ]
    },
    onUploadedFile(url, index) {
      this.newSymbol2[index].doc_url = url
    },
    customLabelFilter(opt) {
      var type = this.typeList.find(x => {
        return x.typeid == opt
      })
      if (type) {
        return type.typename
      } else {
        return ''
      }
    },
    clickShowColumn(item) {
      if (this.showColumn.includes(item)) {
        var filterCheckbox = this.showColumn.filter(result => result !== item)
        this.showColumn = filterCheckbox
      } else {
        this.showColumn.push(item)
      }
    },
    cloneBadges() {
      this.modalAddBadges = false
      this.newSymbol = [
        {
          badgeid: null,
          badgelevel: 0
        }
      ]
    },
    closeDoc() {
      this.modalAddDoc = false
      this.newSymbol2 = [
        {
          doc_name: null,
          doc_url: null,
        }
      ]
    },
    customLabel(opt) {
      var type = this.symbols.find(x => {
        return x.id == opt
      })
      if (type) {
        return type.name
      } else {
        return ''
      }
    },
    customLabelLevel(opt) {
      if (opt) {
        return opt
      } else {
        return ''
      }
    },
    addLevel() {
      this.newSymbol.push({
        badgeid: null,
        badgelevel: 0
      }),
      this.newSymbol2.push({
        doc_name: null,
        doc_url: null
      })
    },
    removeLevel(index) {
      let newSymbols = []
      newSymbols = this.newSymbol.filter((level, ind) => ind !== index)
      this.newSymbol = newSymbols

      let newSymbols2 = []
      newSymbols2 = this.newSymbol2.filter((level, ind) => ind !== index)
      this.newSymbol2 = newSymbols2
    },
    async onSave() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return false
      }
      this.loading = true
      const payload = {
        productid: this.productid,
        badges: this.newSymbol
      }

      const response = await api.createProduct_badges(payload)
      if (response == 200) {
        if (this.typeBadges === 'add') {
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
        } else {
          this.$swal.fire({
            type: 'success',
            title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
            confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
          })
        }

        this.clearAdvancedSearch = false
        this.cloneBadges()
        await this.setupData()
      } else if (response == 300) {
        this.$swal.fire({
          title: 'error',
          type: 'error'
        })
      }
      this.loading = false
    },
    async getBadges() {
      try {
        const data = {
          limit: 999999,
          offset: 0
        }
        this.data = await api.getBadges(data)
        this.symbols = this.data.data
      } catch (e) {
        console.log(e)
      }
    },
    clickDetail(data) {
      this.dataDetail = data.badges
      this.modalDetail = true
      this.productid = data.productid
    },
    async clickDoc(data) {
      let res = await api.getDocument({ productid: data.productid });
      let dataDoc = [];
      if (res && res.length) {
        for (let i = 0; i < res.length; i++) {
          dataDoc.push(res[i])
        }
      }
      this.dataDoc = dataDoc
      this.modalDoc = true
      this.productid = data.productid
    },
    async updataDoc() {
      this.typeDoc = 'edit'
      this.newSymbol2 = this.dataDoc.map(item => {
        return { doc_name: item.doc_name, doc_url: item.doc_url  }
      })
      this.modalAddDoc = true
      this.modalDoc = false
    },
    async updataBadges() {
      this.typeBadges = 'edit'
      this.newSymbol = this.dataDetail.map(item => {
        return { badgeid: item.badgeid, badgelevel: item.badgelevel }
      })
      this.modalAddBadges = true
      this.modalDetail = false
    },
    async deleteMember(id) {
      console.log('id', id)
    },
    clearSearchColumn() {
      this.searchColumn = ''
      this.column = this.columnAll
    },
    changeSearchColumn(name) {
      let outputResult
      if (name.target._value !== '') {
        outputResult = this.columnAll.filter(item => {
          return item.toLowerCase().indexOf(name.target._value.toLowerCase()) !== -1
        })
      } else {
        outputResult = this.columnAll.filter(item => {
          return item
        })
      }
      this.column = outputResult
    },
    clearSearch() {
      this.isSearch = false
      this.clearAdvancedSearch = false
      ;(this.filter = {
        nameAll: null,
        campaign: null,
        category: null,
        type: null,
        memberid: null,
        membername: null,
        productid: null,
        symbols: null
      }),
        this.onSearch()
    },
    async onSearch() {
      this.loading = true
      this.searchloading = true
      this.isSearch = true
      this.page = 1
      await this.setupData()
      this.searchloading = false
      this.showSearchAdvanced = false
      this.loading = false
    },
    setupData() {
      this.getProduct()
      this.getCampaign()
      this.getCategory()
      this.getBadges()
      this.getType()
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.setupData()
      this.loading = false
    },
    async sortPage(pages) {
      let count = Math.ceil(this.total / this.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      if (pages) {
        this.page = parseInt(pages)
        this.loading = true
        await this.setupData()
        this.loading = false
      }
    },
    async exportData() {
      this.loading = true
      await this.getExData()
      this.loading = false
      this.$refs.exbtn.exportxlsx()
    },
    async getProduct() {
      try {
        this.loading = true
        this.data = await api.getProductReport({
          where: this.body,
          page: {
            quantity: this.rowsPerPage,
            page: this.page
          }
        })

        this.total = this.data.count
        this.showData = this.data.data

        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    async getExData() {
      try {
        let data = await api.getProductReport({ where: this.body })
        await this.setEx(data.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getCampaign() {
      this.campaign = await api.getCampaign()
    },

    async getType() {
      try {
        this.type = await api.getType()
        this.typeList = this.type.data
      } catch (error) {
        console.error(error)
      }
    },

    async getCategory() {
      let categories = []
      var params = {
        typeid: this.filter.type ? this.filter.type : null
      }
      let data = await api.getCategory(params)
      data.data.map(item => {
        item.categories.map(items => {
          categories.push({ categoryid: items.categoryid, categoryname: items.categoryname })
        })
      })

      this.category = _.uniqBy(categories, 'categoryname')
    },
    async saveDoc() {
      var isValid = await this.$validator.validate() 
        if (isValid) {
          const obj = {
            productid: this.productid,
            docs: this.newSymbol2
          }
          let res = await api.createDoc(obj)
          if (res == 200) {
            this.addDoc = false
            this.error = false
            this.modalDoc = false
            this.modalAddDoc = false
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
          }
        } else {
          this.error = true
        }
        this.loading = true
        await this.setupData()
        this.loading = false
        this.clearData()
      
    },
    async sendEGP() {
      this.$swal
        .fire({
          title: '<div class="headline primary--text bold7 fs-24">ส่งข้อมูล</div>',
          html: '<div class="primary--text fs-16">คุณแน่ใจหรือไม่ว่าต้องการส่งข้อมูล</div>',
          showCancelButton: true,
          showCloseButton: true,
        })
        .then((result) => {
          if (result.value) {
            this.getProductEGP()
            // api.depaUpdateStatusSME(
            //   { memberid: item.memberid,
            //     id_card: item.id_card,
            //    },
            //   (err, response) => {
            //     if (response.responsecode == 200){
            //       this.getdepamemberinfoall()
            //       this.$swal.fire({
            //         type: 'success',
            //         title: '<div class="headline primary--text bold7 fs-24">ทำรายการสำเร็จ</div>',
            //         text: `${moment(new Date()).format('DD/MM/YY') + ' ' + moment(new Date()).format('HH:mm')
            //           }`,
            //         confirmButtonText: '<span style="color:#FFEF01">ปิด</span>',
            //       })

            //     }
            //     this.loading = false
                
            //   }
            // )
          }
        })
    },
      //console.log("^^");
      //this.loading = true
    //  await this.getProductEGP()
      // this.loading = false
      // this.$refs.exbtn.exportxlsx()
    //},
    async getProductEGP() {
      try {
        this.productsEGP = await api.getProductsEGP()
      } catch (error) {
        console.error(error)
      }
      // try {
      //   this.loading = true
      //   this.data = await api.getProducts({
      //     where: this.body,
      //     page: {
      //       quantity: this.rowsPerPage,
      //       page: this.page
      //     }
      //   })

      //   this.total = this.data.count
      //   this.showData = this.data.data

      //   this.loading = false
      // } catch (error) {
      //   console.error(error)
      // }
    },
    setEx(data) {
      let ex = []
      if (data && data.length) {
        data.forEach(ele => {
          let obj = {
            'ผู้ขาย (Tech Provider)': ele.techprovidername,
            ชื่อสินค้า: ele.productname,
            ราคา: ele.price,
            รายละเอียด: ele.description,
            คะแนน: ele.score,
            ประเภทสินค้า: ele.typename,
            ประเภทลิขสิทธิ์: ele.copyrighttype,
            ตัวแทนขาย: ele.salesrepresentatives,
            เอกสาร: ele.document
          }
          ex.push(obj)
        })
        this.exData = ex
      } else {
        this.exData = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* .depatable td {
  vertical-align: middle;
} */
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntTechproviderandproductreport/main.vue